import React from 'react'
import PresenterControls, { ButtonStatusState } from '@bt-react/components/PresenterControls'
import { TalksPresenterControlsProps } from './types'
import { TooltipPosition } from '@bt-react/components/TooltipWrapper'

/** Returns a Presenter TalksPresenterControls with the content type that was passed to it */
class TalksPresenterControls extends React.Component<TalksPresenterControlsProps> {


  componentDidMount () {

    this.props.checkDevicePermissions()

  }

  /** Add controls back in here with props to decide what to show */

  getMicrophoneStatus = (): ButtonStatusState => {

    if (this.props.isMuted) return 'hidden'
    if (this.props.hasAudioError) return 'error'
    return 'connected'

  }

  getTelephoneStatus = (): ButtonStatusState => {

    if (this.props.isDialInConnected) {

      return this.props.isMuted ? 'hidden' : 'connected'
  }

    return 'disconnected'

  }

  getVideoStatus = (): ButtonStatusState => {

    if (this.props.hasVideoError) return 'error'
    if (this.props.isVideoButtonDisabled) return 'disabled'
    if (this.props.isHidden) return 'hidden'
    return 'connected'

  }

  videoClickHandler = () => {

    if( !this.props.isVideoButtonDisabled ){

      this.props.onClickVideo(this.props.participant.id)
    }
  }

  audioClickHandler = () => {

    if( !this.props.isAudioButtonDisabled ){

      this.props.onClickAudio(this.props.participant.id)
    }
  }

  render () {

    const microphone = this.getMicrophoneStatus()
    const telephone = this.getTelephoneStatus()
    const video = this.getVideoStatus()

    /** N.B. Should look at making the presenter controls comp change which icons are visible dependant on which fns are passed in.
     * Maybe to show presenterControls you pass in a controls prop that is linked to PresenterControls types
     */



    return (
      <div data-bdd={this.props.dataBdd || 'talks-presenter-controls'}>
        <PresenterControls
          isLocal={this.props.isLocal}
          onClickAudio={this.audioClickHandler}
          onClickVideo={this.videoClickHandler}
          onClickSettings={this.props.onClickSettings}
          isVideoButtonDisabled={this.props.isVideoButtonDisabled}
          audioSource={this.props.audioSource || 'microphone'}
          buttonStatus={{
            microphone,
            telephone,
            video
          }}
          background={this.props.background}
          tooltipPosition={TooltipPosition.BOTTOM}
        />
      </div>
    )
  }

}

export default TalksPresenterControls
